import BookingEditForm from 'components/forms/BookingFormFactory/BookingEditForm';
import { ModalBase, PriceDisplay } from 'remote/global';
import { useOperatorsOrdersQuery } from 'api/queries/operators';

type Props = {
  open: boolean;
  onClose: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOrderEditAvailable: boolean;
  bookingNumber: string;
  rideNumber: number;
};

function OrderEditModal({
  open,
  setOpen,
  onClose,
  bookingNumber,
  isOrderEditAvailable,
  rideNumber,
}: Props) {
  const orderQuery = useOperatorsOrdersQuery(open ? bookingNumber : undefined);
  const { data: order, isLoading } = orderQuery;

  if (isLoading || order == null) return null;

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='md'
      title={`#${bookingNumber}`}
      fullWidth
      header={{
        children: (
          <PriceDisplay
            priceExclVat={order.operatorPriceExclVat}
            priceInclVat={order.operatorPriceInclVat}
            unadjustedPriceExclVat={order.unadjustedPriceExclVat}
            unadjustedPriceInclVat={order.unadjustedPriceInclVat}
          />
        ),
      }}
    >
      <BookingEditForm
        orderQuery={orderQuery}
        isOrderEditAvailable={isOrderEditAvailable}
        rideNumber={rideNumber}
        onClose={onClose}
      />
    </ModalBase>
  );
}

export default OrderEditModal;
